export const faqsPl = [
  {
    q: "Ile kosztuje integracja OpenAI / LLM w aplikacji?",
    a: "Prosta integracja (chat w istniejącej appce, jedno API) to zwykle dziesiątki tysięcy zł developmentu plus koszty użycia modelu. MVP z panelem, historią rozmów i moderacją — więcej. Oddzielamy koszt wdrożenia od kosztów utrzymania API.",
  },
  {
    q: "Ile kosztuje chatbot AI podobny do Tidio / Chatbot.com?",
    a: "Zależy od zakresu: widget na stronie, integracja z katalogiem produktów, wielojęzyczność, CRM. Orientacyjnie od prostego MVP po pełniejszą platformę obsługi — wyceniamy po ustaleniu scenariuszy, nie „na oko”.",
  },
  {
    q: "Czy chatbot może być zgodny z RODO / GDPR?",
    a: "Tak — przy odpowiedniej architekturze: dane w UE, kontrola tego, co trafia do modelu, retencja, zgody użytkownika. To szczególnie ważne przy e-commerce i danych klientów.",
  },
  {
    q: "Czy integrujecie AI z istniejącą aplikacją?",
    a: "Tak. Najczęściej dokładamy AI do mobile/web/PWA albo CRM — nie budujemy osobnego „projektu AI od zera”, jeśli nie jest to potrzebne.",
  },
  {
    q: "Chatbot, agent czy rekomendacje — co wybrać?",
    a: "Chatbot odpowiada na pytania i prowadzi rozmowę. Agent wykonuje działania (status zamówienia, CRM). Rekomendacje wspierają katalog lub content. Dobieramy wariant do mierzalnego efektu biznesowego.",
  },
  {
    q: "Jakie są koszty utrzymania AI po wdrożeniu?",
    a: "Głównie użycie API, monitoring jakości odpowiedzi, ewentualne rozszerzenie bazy wiedzy i rozwój scenariuszy. W wycenie zawsze pokazujemy obie strony: development i koszty operacyjne.",
  },
  {
    q: "Czy da się zrobić MVP AI w kilka tygodni / 3 miesiące?",
    a: "Tak — przy wąskim scenariuszu (np. PWA + OpenAI, rekomendacje ze zdjęć, chatbot statusu zamówienia). Szersza platforma obsługi to dłuższy projekt.",
  },
  {
    q: "Czy AI to osobna usługa, czy część aplikacji?",
    a: "Traktujemy AI jako cechę aplikacji — chatbot, LLM, automatyzacja — w ramach mobile, web lub SaaS. Osobna strona pomaga uporządkować zakres i koszty, nie tworzy równoległej oferty.",
  },
] as const;
